import { gql } from '@apollo/client'

/**
 * GraphQL Query Payee Dashboard.
 * @return {dashboard} A GraphQL query.
 */

export const DASHBOARD_ADD_PAYEES_QUERY = gql`
  query payees {
    payees(dashboard: dashboard)
    dashboard
  }
`

/**
 * GraphQL Query Payee Dashboard.
 * @returns {payeeId} A GraphQL query.
 */
export const DASHBOARD_SEARCH_QUERY = gql`
  query billpayPayeeListInquiry(
    $appName: AppNameEnum
    $payeeListInquiryRequest: BillpayPayeeListInquiryRequest
  ) {
    billpayPayeeListInquiry(
      appName: $appName
      payeeListInquiryRequest: $payeeListInquiryRequest
    ) {
      billerList {
        billerId
        billPaymentCutOff
        billerName
        billerSiteUrl
        billerLogoUrl
        billerThumbnailImageUrl
        billerType
        billerZipRequired
        restrictionText
        serviceAddressRequired
        trialPeriodDays
        __typename
      }
      payeeList {
        payeeId
      }
    }
  }
`

export const SEARCH_QUERY_REST_QUERY_GQL = gql`
  query payeeListInquiry($payload: Payload) {
    payeeListInquiryRequest(input: $payload)
      @rest(
        type: "DashboardActivities"
        path: "/potential-payees/search"
        method: "POST"
      ) {
      payeesSearch
      conversion
    }
  }
`
